import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const api = axios.create({ baseURL: API });

export const setToken = (t) => {
  if (t) localStorage.setItem("arabdex_token", t);
  else localStorage.removeItem("arabdex_token");
};
export const getToken = () => localStorage.getItem("arabdex_token");

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
export { API };
